<template>
  <b-container>
    <div class="vdist">
      <b-form-group label="Użytkownik dla którego wystawione ma zostać zlecenie">
        <b-select v-model="userSelected" @change="updateJobsLeft">
          <b-select-option disabled :value="null">wybierz użytkownika...</b-select-option>
          <b-select-option v-for="u in users" :value="u.id" :key="u.id"> {{ u.login }}</b-select-option>
        </b-select>
      </b-form-group>

      <b-form-group label="Maksymalna ilość głosów na parę">
        <b-input-group>
          <b-input type="number" step="1" min="1" max="10" v-model.number="maxVotes" @change="updateJobsLeft"></b-input>
        </b-input-group>
      </b-form-group>

      <b-form-group :disabled="jobsLeft===null"
          label="Ilość zlecanych par. Zlecane są tylko pary na które wybrany użytkownik nie głosował i które nie uzyskały jeszcze maksymalnej ilości głosów.">
        <b-input-group>
          <b-input type="number" step="1" min="1" v-model.number="jobNum"></b-input>
          <b-input-group-append>
            <b-input-group-text>/{{ jobsLeft }}</b-input-group-text>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>

      <b-form-group label="Wybierz przynajmniej jedną kategorię">
        <b-form-checkbox-group v-model="categoriesSelected">
          <b-form-checkbox value="ispair" @click="ispairClick()">para</b-form-checkbox>

          <b-form-checkbox v-for="c in jobCategories" :key="c.name" :value="c.name"
                           :disabled="!categoriesSelected.includes('ispair')">
            {{ c.label }}
          </b-form-checkbox>
        </b-form-checkbox-group>
      </b-form-group>


      <b-button variant="primary" @click="send()" :disabled="!canBeSent()">zleć</b-button>
    </div>
  </b-container>

</template>

<script>

import {api} from '@/utils'
import {tabs} from "@/props";


export default {
  name: 'jobPage',
  components: {},
  props: ["axios"],
  data: function () {
    return {
      jobNum: 1,
      userSelected: null,
      categoriesSelected: [...tabs.map(x => x.name).filter(x=> x!=="aisleft" && x!=="lock")],
      users: [],
      jobsLeft: null,
      maxVotes: 5
    }
  },
  computed: {
    jobCategories() {
      return tabs.slice(1);
    }
  },
  created() {
    this.loadUsers();
  },
  methods: {
    ispairClick() {
      if (this.categoriesSelected.includes("ispair"))
        this.categoriesSelected.splice(0, this.categoriesSelected.length)
    },
    loadUsers() {
      this.axios.get(api("users"))
          .then(resp => {
            this.users = resp.data
          })
    },
    canBeSent() {
      if (this.userSelected === null)
        return false

      if (this.categoriesSelected.length === 0)
        return false

      if (!Number.isInteger(this.jobNum) || this.jobNum <= 0)
        return false

      if (this.jobsLeft===null || this.jobNum>this.jobsLeft)
        return false

      return true
    },
    send() {
      let job = {
        "user_id": this.userSelected,
        "num": this.jobNum,
        "max_votes": this.maxVotes,
        "categories": this.categoriesSelected
      }
      this.axios.post(api("job"), job)
          .then(() => {
            this.userSelected = null
            this.jobsLeft=null
          })
    },
    updateJobsLeft(){
      this.jobsLeft=null
      if(this.userSelected!== null)
        this.axios.post(api("jobsleft"), {user_id: this.userSelected, max_votes: this.maxVotes})
            .then((resp) => {
              this.jobsLeft = resp.data.jobsLeft
            })
    }


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
